<div class="package-type-manage-list">
  <div class="package-type-manage-list__toolbar">
    <mat-form-field appearance="outline" class="package-type-manage-list__search" subscriptSizing="dynamic">
      <mat-label>Search package types</mat-label>
      <input matInput type="text" [formControl]="searchControl" placeholder="Search package types" />
      <mat-icon matPrefix>search</mat-icon>
      @if (isSearching) {
        <mat-hint>Searching...</mat-hint>
      }
    </mat-form-field>
    <button type="button" mat-stroked-button class="package-type-manage-list__create" (click)="createRequested.emit()">
      <mat-icon>add</mat-icon>
      Create
    </button>
  </div>

  @if (editingPackageType) {
    <form class="package-type-manage-list__edit-form" [formGroup]="editForm">
      <mat-form-field appearance="outline">
        <mat-label>Package type</mat-label>
        <input required formControlName="type" type="text" matInput>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Code</mat-label>
        <input required formControlName="code" type="text" matInput>
      </mat-form-field>
      <div class="package-type-manage-list__edit-actions">
        <button type="button" mat-stroked-button (click)="cancelEdit()">Cancel</button>
        <button type="button" mat-flat-button color="primary" [disabled]="!editForm.valid" (click)="saveEdit()">Save</button>
      </div>
    </form>
  }

  <div class="package-type-manage-list__items">
    @for (type of packageTypes; track type.id) {
      <div class="package-type-manage-list__row">
        <span>{{ type.type }} <span class="package-type-manage-list__code">({{ type.code }})</span></span>
        <div class="package-type-manage-list__row-actions">
          <button type="button" (click)="startEdit(type)" mat-stroked-button class="package-type-manage-list__edit">
            Edit
          </button>
          <button type="button" (click)="deletePackageType(type)" mat-stroked-button class="package-type-manage-list__delete">
            Delete
          </button>
        </div>
      </div>
    } @empty {
      <p class="package-type-manage-list__empty">No package types found.</p>
    }
  </div>
</div>
